import axios from 'axios'

import { ROUTES } from 'settings/settings'
import { LogService } from 'services/Log/Log'
import { IUser, IUserToSave } from 'models/models'

export async function saveUser(user: IUserToSave) {
  try {
    const { data }: { data: IUser } = await axios({
      method: 'POST',
      url: `/${ROUTES.users}`,
      baseURL: process.env.REACT_APP_USER_API,
      data: user,
    })

    return { data }
  } catch (error: any) {
    LogService.error({ message: 'getUsers', error })
    return { data: null, error: error.response?.data?.errorMessage }
  }
}
